import React from 'react'
import PropTypes, { InferProps } from 'prop-types'
import { Box, Text } from 'pcln-design-system'
import Modal from '../collections-promo/Modal'
import {
  HotelsTypeAheadForm,
  handleModalContainerOnClick
} from '../../../NEW_SEARCH_SearchForms'
import { formatHotelsURL } from '../../../search-forms/utils/hotels-url-formatters'
import HotelsSearchContainer from '../../../../containers/hotels/HotelsSearchContainer'
import { validatePromoDeals } from '../../../../utils/validateHotels'
import { fireSearchClick } from '../../../../actions/GoogleAnalyticsClickActions'
import { ANALYTICS_CATEGORY, HotelSearchFormModalTypes } from '../../../../constants/Constants'
import CONTENT from '../../../../constants/Content'

const HTL_COLLECTION_MODAL_ID = 'htl-collection-modal'
const HOTEL_TAB_KEY = 'hotels'
const HOME_CONTENT = CONTENT.home

type fireAnalyticsProps = {
  data: object
}

type handleCollectionsSubmitProps = {
  locationObject: object,
  startDate: string,
  endDate: string,
  roomCount: string,
  adultCount: number,
  childrenAges: object,
  dealType: string,
  data: object
}

const fireAnalytics = ({data}: fireAnalyticsProps) => {
  fireSearchClick(
    HOME_CONTENT.forms.hotels.ga.searchClickCollections,
    data,
    ANALYTICS_CATEGORY,
    'Feature Box Modal'
  )

  if (data) {
    fireSearchClick(
      HOME_CONTENT.forms.hotels.ga.collectionsSearchValidSubmission,
      HOME_CONTENT.forms.hotels.ga.searchValidSubmissionLabel
    )
  }
}

const handleCollectionsSubmit = (values: handleCollectionsSubmitProps) => {
  const url = formatHotelsURL({
    ...values,
    dealType: 'COLLECTIONS'
  })
  fireAnalytics(values)
  window.open(url)
}

export default function PricebreakersModal ({ show, onClose }: InferProps<typeof PricebreakersModal.propTypes>) {
  return (
    <Modal
      id={HTL_COLLECTION_MODAL_ID}
      show={show}
      // @ts-ignore
      onClose={onClose}
      onClick={(e: object) => {
        const opts = {
          event: e,
          modalID: HTL_COLLECTION_MODAL_ID,
          tab: HOTEL_TAB_KEY
        }
        handleModalContainerOnClick(opts)
      }}
      isUsingInnerRef
    >
      <Box px={4} pt={3} pb={4}>
        <Box mb={3}>
          <Text color='text' fontSize={[4, null, null, 5]} fontWeight='bold' style={{ lineHeight: 1.25 }}>
            Search Pricebreakers
          </Text>
          <Text color='text' fontSize={[3, null, null, 4]} style={{ lineHeight: 1.25 }}>
            Our highest rated hotels - up to 50% off retail
          </Text>
        </Box>
        <HotelsSearchContainer
          onSubmit={handleCollectionsSubmit}
          validate={validatePromoDeals}
          render={props => (
            <HotelsTypeAheadForm
              {...props}
              typeAhead={{
                endpoint: 'hotels',
                keys: ['location']
              }}
              modalType={HotelSearchFormModalTypes.PRICEBREAKERS}
            />
          )}
        />
      </Box>
    </Modal>
  )
}

PricebreakersModal.defaultProps = {
  onClose: () => {}
}

PricebreakersModal.propTypes = {
  onClose: PropTypes.func,
  show: PropTypes.bool.isRequired
}
